import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
.searcher-box {
    .searcher-input{
        caret-color: #019df4;
        // font-family: var(--color-gp--white);
        background: var(--color-gp--white);
        border: 1px solid ${getColor(COLOR_DICTIONARY.GREY_500)};
        border-radius: 12px;
        width: 100%;
        color: #000;
        outline: none;
        vertical-align: super;
        padding-left: 40px;
        padding-right: 28px;
        padding-top: 12px;
        padding-bottom: 12px;
        -webkit-appearance: none;
    }
    .search-icon-container {
        min-width:22px;
        position: absolute;
        top: 11px;
        padding-left: 2px;
        left: 9px;
        z-index: 2;
        background-color: white;
    }
    .close-icon-container {
        background: transparent;
        border: 0;
        padding: 0;
        cursor: pointer;
        width: 22px;
        height: 22px;
        position: absolute;
        top: 15px;
        right: 6px;
    }
    .searcher-input:focus-visible,
    .close-icon-container:focus-visible {
        outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
        outline-offset: 2px;
    }
    .loading-container {
        position: absolute;
        top: 24px;
        right: 18px;
    }
}
`;
